/* jshint esversion: 8 */
define([
  "computeResource/collections/collection"
], function (
  Collection
) {

  class ProductionServerCollection extends Collection {

    constructor (args) {
      super(args);
    }

  }

  return ProductionServerCollection;
});
